































































































import { AuthStoreHelper, getVehicleData, getVehicleIdByVehiclePlate, RootStoreHelper, VehicleCompanyStoreHelper } from '../../core/mixins';
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import {
    PlayBackInfo,
    PlaybackState,
    mapFromRangeToRange,
    getDateFromDateFormatApi,
    getStringTimeFromDate,
    sortObjectByPropertyName,
    TypeVehicleState,
    getStateByNumber,
    removeAccentsFromString,
    addTimeToDate,
    getNowNoFormat,
    formatDate,
    watchClass,
    hasElements,
    getDictionaryFromChoices,
    parseFloatNumber,
    calculatePercentageOfNumber,
    getDateAsMoment,
    dateIsSameOrAfterSecond,
    dateIsSameOrBefore,
    getDateFormattedAsMoment,
    getMomentPlusTime,
    EventBus,
    TypeEventBus,
    tableSort,
    isNumber
} from '../../core/utils';
import CardPlayBackInfo from './CardPlayBackInfo.vue';
import { dateTypes, diffOptions, UserCustomization } from '../../core/models';
import { UserService } from '../../core/api';
import { getVehiclePlateFromVehicleId, getVehicleVinById }from '../../core/mixins/';
import { Destroyed } from '../../core/decorators';
import { centerVehicleInMap, getUnitByVarDescription, getVariableDescription, VariablesTypes } from '../utils';
import FleetSummaryUserSettings from './FleetSummaryUserSettings.vue';
import multiselect from 'vue-multiselect';
import Sortable from 'sortablejs'
import rowItem from './Table/rowItem.vue';
import { DateRange } from '../../core/utils';
import Loading from 'vue-loading-overlay';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
import SelectedVehiclesChooser from '../../vehicles/components/SelectedVehiclesChooser.vue';

@Component({
    components: { 
        rowItem,
        multiselect,
        Loading,
        Input,
        SimpleTable,
        SelectedVehiclesChooser
     }
})
export default class StatisticsTable extends Mixins(
    RootStoreHelper,
    VehicleCompanyStoreHelper
) {
    @Prop({default: false}) expandedPanel: boolean;
    @Prop({default: 321}) mapClientHeight: boolean;
    @Prop({default: null}) vehicleSelected: null | string;
    @Prop({default(){return []}}) vehiclesWithHistoricalData: string[];
    @Prop({default: {datetime_from:'',datetime_to: ''}}) selectionChartZoom: DateRange;
    variableSelected: null | string = null;
    itemsVariableData: Array<Object> = [];
    headersVariableDataTable: Array<object> = [
        {
            text: 'Vehículo',
            align: 'center',
            value: 'vehicle_description',
            filter: this.filterByVehicleDescription
        },
        {
            text: 'Variable',
            align: 'center',
            value: 'varDescription',
            filter: this.filterByVariableInDatos
        },
        {
            text: 'Medición',
            align: 'center',
            value: 'value'
        },
        {
            text: 'Fecha y Hora',
            align: 'center',
            value: 'datetime_from',
            filter: this.timestampFilter,
            formatter: this.parseDate
        }
    ];
    sortBy: string[] = ['variable', 'description'];
    sortDesc: boolean[] = [false, false];
    variablesList: Array<Object> = [];
    pendingRequestVariableData: boolean = false;
    shouldDisplayNoInformation: boolean = false;
    debounce: any = null;
    searchTableDebounce: string = '';
    noInfoForSelectedVariable: string = 'No hay información para la variable seleccionada';
    noTableData: string = 'No hay datos para mostrar';

    parseDate(value){
        return formatDate(value, true)
    }

    @Emit()
    clearVehicleSelected(){}

    @Emit()
    clearVehiclesSelected(){}


    @Emit()
    updateVehiclesParamsInfo(vehicleId){return vehicleId}

    getVehicleIDFromVehPlate(vehiclePlate) {
        return getVehicleIdByVehiclePlate(vehiclePlate, this.$_getVehiclesFromSelectedCompany);
    }

    deleteVariableFromDataTab(variable) {
        let variableName = variable && variable['description'] ? variable['description'].toLowerCase() : null;
        if (variableName !== null) {
            this.itemsVariableData = this.itemsVariableData.filter(function(item) {
                return item['varDescription'] !== variableName;
            });

            this.variablesList = this.variablesList.filter(function(item) {
                return item['description'].toLowerCase() !== variableName;
            });
        }
        this.setVariableSelected(
            this.variablesList && this.variablesList.length ? this.variablesList[0]['description'] : 'null'
        )
    }

    clearVariableDataTab() {
        this.itemsVariableData = [];
        this.variablesList = [];
    }

    @Watch('itemsVariableData')
    observableItems(items){
        this.displayNoInformationMsg();
        this.reloadAnimation();
    }

    debouncedOnChange(value) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            this.searchTableDebounce = value;
        }, 600);
    }

    displayNoInformationMsg(){
        if (hasElements(this.itemsVariableData)) {
            this.shouldDisplayNoInformation = false;
        }
        this.shouldDisplayNoInformation = true;
    }

    pendingRequest(value){
        this.pendingRequestVariableData = value;
    }

    reloadAnimation(){
        this.pendingRequest(true);

        setTimeout(() => {
            this.pendingRequest(false);
        }, 0);
    }

    setVariableSelected(value){
        this.variableSelected = value;
    }

    customFilterLowerCase(items, search, filter) {
        let userSearch = removeAccentsFromString(search.toString().toLowerCase());
        let filterVariableDescription = removeAccentsFromString(filter.varDescription);
        let filterValue = removeAccentsFromString(filter.value.toString());

        return (
            filter.vehicle_plate.includes(userSearch.toUpperCase()) ||
            filterVariableDescription.includes(userSearch) ||
            filterValue.includes(userSearch)
        );
    }

    customSort(items: object[], sortBy: string[], sortDesc: boolean[]) {
       return tableSort(items, sortBy, sortDesc);
    }

    updateVariableData(variableResponse, variable){
        let self = this;
        if (variableResponse !== 'error') {
            let vehiclePlate = '-';
            let vehicleDescription = '-';
            if (variableResponse && variableResponse.tracking) {
                variableResponse = variableResponse.tracking;
            }
            if (hasElements(variableResponse)) {
                let variableDescription = variable && variable.description ? variable.description : '';
                let varDescription = this.getVarDescription(variableDescription);
                let unit = varDescription !== undefined ? getUnitByVarDescription(varDescription, self.$_getVariables) : '';
                let varChoices: any = variable && variable['choices'] ? getDictionaryFromChoices(variable['choices']) : undefined;
                let variableHasChoices = varChoices !== undefined ? true : false;

                if (variable) {
                    this.variablesList.push(variable);
                    this.setVariableSelected(varDescription);
                }

                for (let i = 0; i < variableResponse.length; i++) {
                    vehiclePlate = getVehiclePlateFromVehicleId(variableResponse[i].vehicle_id, self.$_getVehiclesFromSelectedCompany);
                    vehicleDescription = getVehicleData(variableResponse[i].vehicle_id, 'description', self.$_getVehiclesFromSelectedCompany, '');
                    for (let b = 0; b < variableResponse[i].data.length; b++) {
                        let variableInfo = variableResponse[i].data[b];
                        let variableValue = variableInfo.value;
                        if(variableValue == null && variableInfo.hasOwnProperty('raw_value')){
                            variableValue = variableInfo['raw_value']
                        }

                        if(isNaN(variableValue)){
                            variableValue = variableValue.toString().toLowerCase();
                        }else{
                            variableValue = parseFloatNumber(variableValue);
                        }

                        

                        let itemTimestamp = variableInfo.timestamp;

                        if (variableHasChoices) {
                            let roundValue = parseInt(variableValue);
                            if(varChoices[roundValue]){
                                variableValue = varChoices[roundValue].toLowerCase();
                            }
                        }

                        if(unit !== undefined && unit !== ''){
                            variableValue  += ` ${unit}`;
                        }

                       
                        //agrego fila para tabla de Datos
                        
                        let newRow = {
                            value: variableValue,
                            datetime_from: itemTimestamp,
                            varDescription: varDescription.toLowerCase(),
                            vehicle_plate: vehiclePlate,
                            vehicle_description: vehicleDescription
                        };

                        this.itemsVariableData.push(newRow);
                    }
                }
            } else {
                // window.console.log("sin datos");
            }
            this.clearVehicleSelected();
            this.variablesList.sort();
        }
    }

    getVarDescription(variable){
        return getVariableDescription(variable);
    }

    timestampFilter(currentRowValue) {
        let format = dateTypes.dateFormatFromDisplayInfoBracketsSs;
        currentRowValue = getDateAsMoment(this.parseDate(currentRowValue), format);
        let dateFrom = getDateAsMoment(this.selectionChartZoom.datetime_from, format);
        let dateTo = getDateAsMoment(this.selectionChartZoom.datetime_to, format);
        if (!this.existSelectionInChart) {
            return true;
        }
        if (
            dateIsSameOrAfterSecond(currentRowValue, dateFrom) && dateIsSameOrBefore(currentRowValue, dateTo)
        ) {
            return true;
        }
        return false;
    }

    filterByVariableInDatos(value) {
        //Filter by "variable" in "Datos" table
        if (this.variableSelected == 'null' || this.variableSelected == null) {
            return true;
        }
        return value.toString().toLowerCase() === this.variableSelected.toLowerCase();
    }

    filterByVehicleDescription(vehicleDescription: string) {
        return this.vehicleSelected == null ? true : vehicleDescription === this.vehicleSelected;
    }

    getMomentParsedTime(time){
        return getMomentPlusTime(time)
    }

    get getItemsPerPageOptions(){
        return this.expandedPanel ? [30, 50, 100, -1] : [15, 30, 50, 100, -1]
    }

    get existSelectionInChart() {
        if (this.selectionChartZoom.datetime_from !== '' && this.selectionChartZoom.datetime_to !== '') {
            return true;
        }
        return false;
    }

    get getDatosTableHeight() {
        if (this.expandedPanel) {
            return calculatePercentageOfNumber(this.mapClientHeight, 75);
        }
        return 321;
    }

    get getItemsVariableData() {
        return this.itemsVariableData;
    }

    get shouldDisplayVariableDataTable() {
        return hasElements(this.itemsVariableData) || !this.pendingRequestVariableData;
    }
    

    mounted(){
        
    }

}
